import { useSwr } from "hooks/atPort/useSwr";

export const useFindSystemNotificationById = (id: string) => {
  const { data } = useSwr<AtPortSystemNotification>(`/system-notification/${id}`);

  return { data };
};
